import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi.js";
import useShowLoader from "../common/loading-widgets/useShowLoader.js";
import Page from "../common/page/Page.js";
import SignUpForm from "./SignUpForm.js";
import "./SignUpPage.scss";

export default function SignUpPage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();

  useShowLoader(tLoading, "SignUpPage");

  return (
    <Page className="SignUpPage">
      <Page.Title
        text={t("authentication-ui:sign_up_page_title")}
        loading={tLoading}
      />
      <Page.Content>
        <div className={"SignUpPage-div"}>
          <Row>
            <Col className="sign-up-block-col">
              <SignUpBlock />
            </Col>
          </Row>
        </div>
      </Page.Content>
    </Page>
  );
}

function SignUpBlock() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading);
  return (
    <div className="SignUpBlock">
      <Row>
        <Col>
          <h1>{t("authentication-ui:sign_up_title")}</h1>
        </Col>
      </Row>
      <Row>
        <Col className="singn-up-form-col">
          <div className="sign-up-form-div">
            <SignUpForm />
          </div>
        </Col>
      </Row>
    </div>
  );
}
